<button
  (click)="onClick()"
  [class.active]="active"
  [class.disabled-hover]="disabledHover"
  [class.is-hovered]="isHovered"
  [class.loading-mode]="isLoading"
  [class.medium]="size === 'medium'"
  [class.small]="size === 'small'"
  [disabled]="disabled"
  class="{{type}} {{color}}">
  @if (isLoading) {
    <div class="loading">
      <div class="spinner"></div>
    </div>
  } @else {
    @if (tooltipText && !disabled) {
      <i
        [actions]="actions"
        [positionTooltip]="positionTooltip"
        [textAlign]="textAlign"
        appAwesomeTooltipV2
        class="{{icon}} {{ iconsSize }}"
        tooltipText="{{ tooltipText }}"
      ></i>
    } @else {
      <i class="{{icon}} {{ iconsSize }}"></i>
    }
  }
</button>
